import { api } from './base-api';
import { Permission } from '../../types/permission';

export const permissionsApi = {
  async list(): Promise<Permission[]> {
    const { data } = await api.get<Permission[]>('/admin/permissions');
    return data;
  },
};
